/**
* 入库操作 国外卡
*/
<template>

	<div style="margin: 20px 20px;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<!-- 卡的数据 -->
		<el-descriptions title="卡" border style="padding-bottom: 30px;">
			<el-descriptions-item label="卡号">{{ iccid }}</el-descriptions-item>
			<el-descriptions-item label="卡类型">
			      <el-tag size="small">国际卡</el-tag>
			    </el-descriptions-item>
			<el-descriptions-item label="蓝牙地址">{{ mac }}</el-descriptions-item>
		</el-descriptions>

		<!-- 已购套餐包 -->
		<el-table :data="boughtPackageList" stripe border
			style="width: 100%; flex: 1; overflow: auto;" :default-sort="{ prop: 'createTime', order: 'descending' }">
			<el-table-column type="index" :index="1"></el-table-column>
			<el-table-column prop="varvalue" label="套餐名称" align="center"></el-table-column>
			<el-table-column prop="effectTime" label="激活时间" align="center"></el-table-column>
			<el-table-column prop="expireTime" label="过期时间" align="center"></el-table-column>
			<el-table-column prop="userFlow" label="用量" align="center"></el-table-column>
			<el-table-column prop="varunit" label="流量单位" align="center"></el-table-column>
			<el-table-column prop="days" label="有效天数" align="center"></el-table-column>
			<el-table-column fixed="right" label="操作" width="100" align="center">
				<template slot-scope="scope">
					<el-button v-if="isShowDisable(scope.$index)" @click="disablePackage(scope.$index)" type="text"
						size="small">失效</el-button>
					<el-button v-if="isShowRefund(scope.$index)" @click="refundPackage(scope.$index)" type="text"
						size="small">退订</el-button>
				</template>
			</el-table-column>
		</el-table>


		<!-- 可购套餐 -->
		<ul style="margin-top: 30px;">
			<li v-for="(data, index) in packageList" :key="index">
				<el-descriptions :title="getPackageList(index,1)" border style="padding-bottom: 30px;">
					<template slot="extra">
						<el-button type="primary" size="small" @click="charge4GPackage(data.packageid)">购买套餐</el-button>
					</template>
					<el-descriptions-item label="套餐id">{{ data.packageid }}</el-descriptions-item>
					<el-descriptions-item label="套餐名称"> {{ data.packagename }} </el-descriptions-item>
					<el-descriptions-item label="套餐销售价">{{ data.salesprice }}</el-descriptions-item>
					<el-descriptions-item label="套餐详情">{{ data.package_DETAILS }}</el-descriptions-item>
					<el-descriptions-item label="套餐参考价">{{ data.reference_PRICE }}</el-descriptions-item>
				</el-descriptions>
			</li>
		</ul>


		<!--  -->

	</div>

</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				iccid: "",
				mac: "",
				boughtPackageList: [], //已购套餐包列表
				packageList: [], //可购套餐包列表
			};
		},
		mounted() {
			this.iccid = this.$route.params.iccid;
			this.mac = this.$route.params.mac;

			this.queryPruchasedPackages(); //查询当前iccid下已购买的套餐包
			this.queryPackageInfo(); //查询iccid下可购买的套餐包
		},
		methods: {
			queryPruchasedPackages() {
				this.isDataLoading = true;
				axios.get(this.$p_url + '/charge/4G/iccid/queryPurchasedPackages?iccid=' + this.iccid, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("查询当前iccid下已购买的套餐包的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.boughtPackageList = response.data.data.mealList; //已购买的套餐列表
						}

					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			queryPackageInfo() {
				axios.get(this.$p_url + '/charge/4G/iccid/queryPackageInfo?iccid=' + this.iccid, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("查询iccid下可购买的套餐包的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.packageList = response.data.data; //可以购买的套餐列表
						}

					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});
			},
			charge4GPackage(packageId) {
				//充值并使用套餐包
				axios.post(this.$p_url + '/charge/4G/iccid/charge4GPackage', {
						iccid: this.iccid,
						packageId: packageId,
						num: 1, //购买数量
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("充值并使用套餐包的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.open2("购买成功！");
							this.queryPruchasedPackages(); //查询当前iccid下已购买的套餐包
						} else {
							this.open4("购买失败！");
						}

					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});

			},
			disablePackage() {
				//设置套餐失效
				axios.post(this.$p_url + '/charge/4G/iccid/disablePackage', {
						iccid: this.iccid,
						orderNo: "",
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("设置套餐失效的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.open2("失效成功！");
							this.queryPruchasedPackages(); //查询当前iccid下已购买的套餐包
						} else {
							this.open4("失效失败！");
						}

					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});
			},
			refundPackage() {
				//设置套餐退订
				axios.post(this.$p_url + '/charge/4G/iccid/refundPackage', {
						iccid: this.iccid,
						orderNo: "",
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("设置套餐退订的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.open2("退订成功！");
							this.queryPruchasedPackages(); //查询当前iccid下已购买的套餐包
						} else {
							this.open4("退订失败！");
						}

					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});

			},
			isShowDisable(index) {
				if (this.boughtPackageList[index].userFlow > 0) {
					return false;
				} else {
					return false;
				}
			},
			isShowRefund(index) {
				if (this.boughtPackageList[index].userFlow > 0) {
					return true;
				} else {
					return true;
				}
			},
			getPackageList(index, type) {
				switch (type) {
					case 0:
						return "已购  套餐" + (index + 1);
						break
					case 1:
						return "可购  套餐" + (index + 1);
						break
				}
			},
			open2(string) {
				this.$message({
					message: string,
					type: 'success'
				});
			},
			open4(string) {
				this.$message.error(string);
			},
		},
	};
</script>

<style>
</style>